import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL;

function getFuncElementList() {
    return axios.get(`${url}/new_orders/get_func_element_list`)
        .then(response => {
            return {
                funcElementList: response.data,
            };
        });
}

function addNewFuncElement(params) {
    const payload = params;
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/new_orders/add_func_element`, payload, options)
        .then(response => {
            return {
                newFuncElement: response.data
            };
        }).catch(err => {
            return {
                newFuncElement: err.response.data
            };
        });
}

function getFuncTranslates(params) {
    let needleUrl = `${url}/new_orders/get_func_translates`;
    if (params) {
        needleUrl += '/' + params;
    }
    return axios.get(needleUrl)
        .then(response => {
            return {
                funcTranslates: response.data,
            };
        });
}

export default {
    getFuncElementList,
    addNewFuncElement,
    getFuncTranslates
};